import { encodeQueryItem } from 'ufo';
import { type ProviderGetImage } from '@nuxt/image';
// @ts-ignore
import { createOperationsGenerator } from '#image';

const cloudflareBase = 'https://media.octane.store';
const operationsGenerator = createOperationsGenerator({
	keyMap: {
		width: 'width',
		height: 'height',
		dpr: 'dpr',
		fit: 'fit',
		gravity: 'g',
		quality: 'q',
		format: 'format',
		sharpen: 'sharpen',
	},
	valueMap: {
		fit: {
			cover: 'cover',
			contain: 'contain',
			fill: 'scale-down',
			outside: 'crop',
			inside: 'pad',
		},
		gravity: {
			auto: 'auto',
			side: 'side',
		},
	},
	joinWith: ',',
	formatter: (key: any, val: any) => encodeQueryItem(key, val),
});

const defaultModifiers = {};

// https://developers.cloudflare.com/images/image-resizing/url-format/
export const getImage: ProviderGetImage = (src, { modifiers = {} } = {}) => {
	const isCloudflareUrl = src.includes(cloudflareBase);

	delete modifiers.quality;
	const mergeModifiers = {
		...defaultModifiers,
		...modifiers,
	};
	let operations = operationsGenerator(mergeModifiers as any);
	let url = src;
	if (isCloudflareUrl) {
		const path = src.replace(cloudflareBase, '');
		url = `${cloudflareBase}/cdn-cgi/image/${operations}${path}`;
	} else {
		operations = operations.replace(',', '&');
		// e.g., https://cdn.shopify.com/static/
		// if src already has query params, append & to the end
		url = src.includes('?') ? `${src}&${operations}` : `${src}?${operations}`;
	}
	return { url };
};

export const getResizedImage = (
	url: string,
	width: number,
	height?: number,
): string => {
	const params: string[] = [`width=${width}`, 'format=webp'];
	if (height !== undefined) {
		params.push(`height=${height}`);
	}

	if (url.includes(cloudflareBase)) {
		const path = url.replace(cloudflareBase, '');
		const paramString = params.join(',');
		return `${cloudflareBase}/cdn-cgi/image/${paramString}${path}`;
	}

	const prams = params.join('&');
	return url.includes('?') ? `${url}&${prams}` : `${url}?${prams}`;
};
